import { SectionTimeSlots } from '../../../views/Section/SectionListView/types';

const formatSchedule = (sectionTimeSlots: SectionTimeSlots[]) => {
  if (!sectionTimeSlots || sectionTimeSlots.length === 0) {
    return '-';
  }

  return sectionTimeSlots.map((sts, index) => {
    const { timeSlot } = sts;
    let startTime = '';
    let endTime = '';
    if (timeSlot.startTime) {
      startTime = typeof timeSlot.startTime === 'string'
        ? timeSlot.startTime.slice(0, 5)
        : String(timeSlot.startTime);
    }
    if (timeSlot.endTime) {
      endTime = typeof timeSlot.endTime === 'string'
        ? timeSlot.endTime.slice(0, 5)
        : String(timeSlot.endTime);
    }
    const weekDay = timeSlot.weekDay || '';
    const timeString = weekDay
      ? `${weekDay} ${startTime} hrs - ${endTime} hrs`
      : `${startTime} hrs - ${endTime} hrs`;
    return index === 0 ? timeString : `, ${timeString}`;
  }).join('');
};

const formatTeachers = (sectionTeachers: Array<{ teacher: { user: { teacherName: string } } }>) => {
  if (!sectionTeachers || sectionTeachers.length === 0) {
    return 'Por definir';
  }
  return sectionTeachers.map((st) => st.teacher.user.teacherName).join(', ');
};

export { formatSchedule, formatTeachers };
